export default __webpack_public_path__ + "static/himshwet-gaurav-124d2211f8605d18aaad9e1804e5f16d.png";